export default __webpack_public_path__ + "static/media/icon-social-in.88a28f96.svg";